<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong>UPSI Emails Log</strong>
        </span>

    </div>

    <section class="card search-box">
        <div class="card-header" (click)="toggleSearchDiv()">Modify Search <span
                class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
        <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">

            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-2">
                        <label>Subject:</label>
                    </div>

                    <div class="col-md-2">
                        <div class="form-group">
                            <label> Email To:</label>
                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="form-group">
                            <label> Email Cc:</label>
                        </div>
                    </div>

                    <div class="col-md-6">

                        <label>Sent Date Range:</label>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-2">
                        <div class="input-group">
                            <input class="form-control" [(ngModel)]="EmailSubject"
                                [ngModelOptions]="{standalone: true}">

                        </div>
                    </div>

                    <div class="col-md-2">
                        <div class="input-group">
                            <input class="form-control" [(ngModel)]="EmailAddressTo"
                                [ngModelOptions]="{standalone: true}">

                        </div>

                    </div>
                    <div class="col-md-2">
                        <div class="input-group">
                            <input class="form-control" [(ngModel)]="EmailAddressCc"
                                [ngModelOptions]="{standalone: true}">

                        </div>

                    </div>
                    <div class="col-md-6">
                        <div class="input-group" (click)="$event.stopPropagation()">

                            From:&nbsp;
                            <input class="form-control" [(ngModel)]="SearchDateFrom" style="padding:6px;z-index: 0;"
                                placeholder="dd-mm-yyyy" ngbDatepicker #c="ngbDatepicker"
                                (focus)="c.toggle();r.close();" (document:click)="c.close();"
                                [ngModelOptions]="{standalone: true}">
                            <button class="input-group-addon" (click)="c.toggle();r.close();" type="button">
                                <span class="fa fa-calendar"
                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button> &nbsp;&nbsp; To:&nbsp;
                            <input class="form-control" [(ngModel)]="SearchDateTo" style="padding:6px;z-index: 0;"
                                placeholder="dd-mm-yyyy" ngbDatepicker #r="ngbDatepicker"
                                (focus)="r.toggle();c.close();" (document:click)="r.close();"
                                [ngModelOptions]="{standalone: true}">
                            <button class="input-group-addon" (click)="r.toggle();c.close();" type="button">
                                <span class="fa fa-calendar"
                                    style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button>
                        </div>

                    </div>

                </div>
            </div>
            <div class="col-md-12">
                <div class="col-sm-2">
                    <label>&nbsp;&nbsp;&nbsp;</label>
                    <div class="input-group">

                        <button type="button" class="btn btn-sm btn-primary mb-2" (click)=" searchData();">
                            <i class="fa fa-search"></i>&nbsp;Search</button>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" class="btn btn-sm btn-default mb-2 btn-clear" (click)="clear()">
                            <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                    </div>
                </div>
            </div>



        </div>
    </section>


    <div class="card-block datatable-card-block">
        <div class="row">
            <div class="col-md-12">
                <div class="margin-bottom-50">
                    <div class="table-responsive">


                        <table id="EmailsLogsT" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
                            class="table table-hover compact cell-border nowrap stripe" id="CsvUploadtable"
                            style="cursor: pointer;">
                            <thead>
                                <tr>
                                    <th style="min-width:200px">Subject</th>
                                    <th style="min-width:200px">To </th>
                                    <th style="min-width:200px">Cc </th>
                                    <th style="min-width:200px">Sent Date</th>
                                    <th style="min-width:100px">Text</th>
                                    <th style="display: none">Sent Date</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let d of EmailsLogs; let count=index" style="line-height: 25px;">
                                    <td style="min-width:200px">{{d.Subject }}</td>
                                    <td style="min-width:200px">
                                        <li *ngFor="let eTo of d.To"> {{maskEmail(eTo)}}</li>
                                    </td>
                                    <td style="min-width:200px">
                                        <li *ngFor="let eCc of d.Cc"> {{maskEmail(eCc)}}</li>
                                    </td>
                                    <td style="min-width:200px">
                                        {{d.CreatedDate | date : "dd-MM-y"}}
                                    </td>

                                    <td style="min-width:100px">

                                        <button type="button" (click)="viewEmails(d.EmailText, d.CreatedDate)"
                                            class="btn-sm btn btn-warning" title="View">
                                            <span class="fa fa-eye"></span>

                                        </button>
                                    </td>
                                    <td style="display: none">
                                        {{d.CreatedDate | date : "yMMddHHmm"}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="modal" id="ViewHtmlEmail" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false"
        aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog  modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDeletion">
                        Email Text (Sent Date :- <span id="sentdate"></span> )</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                    </button>

                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12" id="htmldata">

                        </div>
                    </div>
                </div>
                <div class="modal-footer">

                    <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Ok</button>
                </div>
            </div>
        </div>
    </div>





</section>
<app-alert></app-alert>